import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import EmployeesSap from "./EmployeesSap";
import EmployeesLog from "./EmployeesLog";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function LabTabs() {
  const [value, setValue] = React.useState(0);
  const { name } = useSelector((state) => state.auth);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const classes = useStyles();

  return (
    <div className="row bg-white rounded  mt-6 mb-6">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Biometrik hərəkət hesabatı </h1>
      </div>
      <div className={`${classes.root} overflowDesignn`}>
        <AppBar position="static">
          <Tabs value={value} onChange={handleChange}>
            <Tab label="DAXİLİ" />
            {name == "Starex" && <Tab label="İşə Gəlməyənlər" />}
          </Tabs>
        </AppBar>
        {value === 0 && (
          <TabContainer>
            <EmployeesSap />
          </TabContainer>
        )}
        {value === 1 && name == "Starex" && (
          <TabContainer>
            <EmployeesLog />
          </TabContainer>
        )}
      </div>
    </div>
  );
}
